import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ORG } from '../landing/landing.content';

@Component({
  selector: 'app-workspace-mobile-brand',
  standalone: true,
  imports: [RouterLink],
  styleUrl: './workspace-mobile-brand.component.css',
  template: `
    <a routerLink="/" class="mobile-bar__brand" aria-label="PDA home">
      <img
        class="emblem-img"
        src="/assets/tenants/pda/logo.png"
        width="40"
        height="40"
        alt="Prayagraj Development Authority (PDA) logo"
      />
      <div class="brand-text">
        <p class="gov-sub">Government of Uttar Pradesh</p>
        <p class="org-name">{{ ORG.fullName.en }}</p>
        <p class="org-alt hi-line">{{ ORG.fullName.hi }}</p>
      </div>
    </a>
  `,
})
export class WorkspaceMobileBrandComponent {
  readonly ORG = ORG;
}
